import Vue from "vue";
import Vuex from "vuex";

import account from "./modules/account.store";
import admin from "./modules/admin.store";
import alert from "./modules/alert.store";
import app from "./modules/app.store";
import auth from "./modules/auth.store";
import autocomplete from "./modules/autocomplete.store";
import beforeunload from "./modules/beforeunload.store";
import breadcrumbs from "./modules/breadcrumbs.store";
import callcenter_client from "./modules/callcenter.client.store";
import callcenter_order from "./modules/callcenter.order.store";
import coauthor from "./modules/coauthor.store";
import config from "./modules/config.store";
import constant from "./modules/constant.store";
import coupon from "./modules/coupon.store";
import course from "./modules/course.store";
import discount from "./modules/discount.store";
import finance from "./modules/finance.store";
import htmlClass from "./modules/htmlclass.store";
import integration from "./modules/integration.store";
import invoice from "./modules/invoice.store";
import item from "./modules/item.store";
import loading from "./modules/loading.store";
import partner from "./modules/partner.store";
import payout from "./modules/payout.store";
import project from "./modules/project.store";
import project_client from "./modules/project.client.store";
import project_landing from "./modules/project.landing.store";
import project_order from "./modules/project.order.store";
import settings from "./modules/settings.store";
import statistics from "./modules/statistics.store";
import tariffication from "./modules/tariffication.store";
import user from "./modules/user.store";
import verify from "./modules/verify.store";
import referral from "./modules/referral.store";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    account,
    admin,
    alert,
    app,
    auth,
    autocomplete,
    beforeunload,
    breadcrumbs,
    callcenter_client,
    callcenter_order,
    coauthor,
    config,
    constant,
    coupon,
    course,
    discount,
    finance,
    htmlClass,
    integration,
    invoice,
    item,
    loading,
    partner,
    payout,
    project,
    project_client,
    project_landing,
    project_order,
    settings,
    statistics,
    tariffication,
    user,
    verify,
    referral,
  },
});
